const STORAGE_KEY = 'wordReplacements'

export const getWordReplacements = () => {
  const stored = localStorage.getItem(STORAGE_KEY)
  return stored ? JSON.parse(stored) : []
}

export const saveWordReplacements = (replacements) => {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(replacements))
}

export const addWordReplacement = (inputWord, replacementWord) => {
  const replacements = getWordReplacements()
  replacements.push({ inputWord, replacementWord })
  saveWordReplacements(replacements)
}

export const removeWordReplacement = (inputWord) => {
  const replacements = getWordReplacements()
  const filtered = replacements.filter((r) => r.inputWord !== inputWord)
  saveWordReplacements(filtered)
}

export const checkForWordReplacement = (text) => {
  if (!text) return text

  if (typeof text !== 'string') return text

  const replacements = getWordReplacements()
  let result = ''
  let remainingText = text

  while (remainingText.length > 0) {
    // Find the next word (non-whitespace characters)
    const wordMatch = remainingText.match(/^\S+/)
    if (wordMatch) {
      const word = wordMatch[0]
      let replacement = word
      for (const { inputWord, replacementWord } of replacements) {
        if (word === inputWord) {
          replacement = replacementWord
          break
        }
      }
      result += replacement
      remainingText = remainingText.substring(word.length)
    } else {
      // No word found, so we're at whitespace
      // Find all consecutive whitespace
      const whitespaceMatch = remainingText.match(/^\s+/)

      if (whitespaceMatch) {
        const whitespace = whitespaceMatch[0]
        result += whitespace
        remainingText = remainingText.substring(whitespace.length)
      } else {
        // This shouldn't happen, but safety break
        break
      }
    }
  }
  // let words = text.trim().split(/\s+/)
  // if (words.length === 0) return text

  // words.forEach((word, index) => {
  //   for (const { inputWord, replacementWord } of replacements) {
  //     if (word === inputWord) {
  //       console.log("🚀 ~ checkForWordReplacement ~ word:", word)
  //       words[index] = replacementWord
  //     }
  //   }
  // })

  return result
}

// Helper function to escape special regex characters
const escapeRegExp = (string) => {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
}
